import React from 'react'
import cn from 'classnames'
import Tag from './Tag'
import trackEvent from '../../../utils/track-event'

/** @param {import("./TagList").TagListProps} props */
export default function TagList(props) {
    const {
        tags,
        containerClassName = 'tag-list',
        itemClassName = 'tag-list__item',
        withoutContainer = false,
        withChildren = false,
        tagClick,
    } = props

    const items = (
        <For each="tag" of={tags}>
            <div
                className={cn(itemClassName, {
                    [`${itemClassName}_openable`]:
                        tag.children && tag.children.length,
                })}
                key={tag.name}
            >
                <Tag tag={tag} handleClick={tagClick}>
                    <If condition={withChildren && tag.children.length}>
                        <TagList
                            tags={tag.children}
                            tagClick={(tagName) => () => {
                                trackEvent({
                                    category: 'store button',
                                    action: 'tag link click',
                                    label: tagName,
                                })
                            }}
                            withChildren={false}
                        />
                    </If>
                </Tag>
            </div>
        </For>
    )

    return withoutContainer ? (
        items
    ) : (
        <div className={containerClassName}>{items}</div>
    )
}
